<script setup lang="ts">
import { RouterLink } from 'vue-router';
import BaseBadge from '@/components/ui/BaseBadge.vue';
import AiBadgePill from './AiBadgePill.vue';
import type { components } from '@/api/generated/schema';
import { SEVERITY_BADGE, SEVERITY_LABEL, STATUS_BADGE, STATUS_LABEL } from './issue-enums';

type RelatedIssueDto = components['schemas']['RelatedIssueDto'];

interface Props {
  related: RelatedIssueDto[];
}
defineProps<Props>();
</script>

<template>
  <div
    v-if="related.length > 0"
    class="bg-surface border border-border rounded-lg overflow-hidden"
    data-testid="related-issues"
  >
    <ul class="divide-y divide-border">
      <li v-for="r in related" :key="r.id">
        <RouterLink
          :to="`/issues/${r.id}`"
          class="flex items-center gap-3 px-4 py-3 hover:bg-canvas-soft transition-colors no-underline"
        >
          <BaseBadge :variant="SEVERITY_BADGE[r.severity] ?? 'info'">
            {{ SEVERITY_LABEL[r.severity] ?? String(r.severity) }}
          </BaseBadge>
          <span class="flex-1 text-body text-fg truncate">{{ r.title }}</span>
          <BaseBadge :variant="STATUS_BADGE[r.status] ?? 'info'" :no-dot="true">
            {{ STATUS_LABEL[r.status] ?? String(r.status) }}
          </BaseBadge>
        </RouterLink>
      </li>
    </ul>

    <!-- Teal footer AI insight per spec §2.2.2 -->
    <div class="px-4 py-2 bg-teal-50 border-t border-teal-100 flex items-center gap-2">
      <AiBadgePill label="AI" />
      <span class="text-caption text-teal-700">
        {{ related.length }} related {{ related.length === 1 ? 'issue' : 'issues' }} matched by AI similarity
      </span>
    </div>
  </div>
</template>
